// extracted by mini-css-extract-plugin
export default {"container":"Biography_container__kaKp3","biography":"Biography_biography__v7znN","skillsList":"Biography_skillsList__8KNrM"};